<template>
  <div>
    <!--- Enter application details -------->
    <div
      v-if="!sent"
      style="padding: 100px 0 30px 0;"
    >    
      <div class="container">             
        <div class="col-md-5  ml-auto mr-auto ">       
          <center>
            <label v-html="$t('Contact.Position')" />
            <h2 style>
              {{ this.Contact.Position }}
            </h2>
          </center>     
          <form
            id="contact-form"
            enctype="multipart/form-data"
          >                        
            <div class="row">                    
              <label v-html="$t('Contact.Name')">Name</label>
              <input
                v-model="Contact.Name"
                aria-describedby="addon-right addon-left"
                class="custom_form"
              >

              <label v-html="$t('Contact.Phone')">Phone Number</label>
              <input
                v-model="Contact.Phone"
                aria-describedby="addon-right addon-left"
                class="custom_form"
              >

              <label v-html="$t('Contact.Email')">Email</label>
              <input
                v-model.trim="$v.Contact.Email.$model"
                aria-describedby="addon-right addon-left"
                class="custom_form"
                :class="{ 'custom_form error': $v.Contact.Email.$error }"
              >              
              
              <label v-html="$t('Contact.Message')">Your Message </label>
              <textarea
                v-model="Contact.Message"
                v-model.trim="$v.Contact.Message.$model"
                class="custom_form"
                rows="4"
                required="required"
                data-error="Type Message Here "
                style="height:200px"
                :class="{ 'error': $v.Contact.Message.$error }"
              />                                
              
              <label v-html="$t('Contact.SendResume')">Send us your Resume (max filesize 4MB)</label>
                      
              <input
                id="file"
                ref="file"
                type="file"
                @change="handleFileUpload()"
              >
              
              <!--
              <br>
              <input type="file" id="file1" ref="file1" v-on:change="handleFileUpload()" style="display:none">
              <button style="width:120px; height:30px;" onclick="document.getElementById('file1').click()">test choose file</button>   
              -->
              
              <br>
              <label v-if="filesize > 4">File to Large : {{ this.filesize }} MB</label>

              <div
                v-if="filesize <= 4"
                style="width:100%;"
              >
                <div
                  class="send-button"
                  style="float:right;"
                >
                  <button
                    type="button"
                    class=" btn-lg hoverblue"
                    @click="sendmessage"
                    v-html="$t('General.Sendmessage')"
                  >
                    <!---->Send Message<!---->
                  </button>
                </div>
              </div>
            </div>                
          </form>       
        </div>    
      </div>
    </div>
    <!----------------message sent ------------------>
    <div v-if="sent">
      <div class="page-header">      
        <parallax
          class="page-header-image"
          style="background-image: url('img/transplus_landing.jpg')"
        />
        <div class="content-center">
          <div class="container">
            <h1 class="title">
              Thank you for your application
            </h1>
            <center>
              <button
                class="closeButton"
                type="button"
                onclick="window.close();"
              >
                Close
              </button>
            </center>
          </div>
        </div>
      </div>                    
    </div>
  </div>
</template>
<script>

import { Card } from '@/components';
import axios from 'axios'
import { required, email,minLength } from 'vuelidate/lib/validators'

export default {
  validations: {
    Contact: {
      Name: { required },
      Phone: { required },        
      Email: { required, email },
      Message: { minLength: minLength(10) }
    }
  },
  
  data() {
    return {    
      year: new Date().getFullYear(),
      Contact: {
        Name: '',
        Phone: '',
        Email: '',
        Message: '',
        Position: ''
      },      
      file: '',
      filesize: 0,
      sent: false
    };
  },
  mounted() {
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been rendered
      this.Contact.Position = this.$route.query.position;
    })
  },
  methods:{
    handleFileUpload(){        
        this.file = this.$refs.file.files[0];
        this.filesize = ((this.$refs.file.files[0].size/1024)/1024).toFixed(2); // MB        
    },
    sendmessage() {

        console.log(JSON.stringify(this.Contact))
        
        // Append file to formData
        let formData = new FormData();
        formData.append('file', this.file);        
        formData.append('contact', JSON.stringify(this.Contact));


        this.$v.Contact.$touch();
        // if its still pending or an error is returned do not submit
        if (this.$v.Contact.Email.$error || this.$v.Contact.Message.$error) {        
          return;
        }
        
        axios.post('https://api.transplus.com/sendresume/', formData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        ).then((response) => {
          //alert(JSON.stringify(response))
          //window.scrollTo(0, 0);
          alert("Message Sent")
          this.sent = true;
          //window.close();
          //this.$router.push('/');          
        })
        .catch(e => {
          alert(e)
          console.log(e)
        })         
    },    
  }    
};
</script>
<style scoped>
::placeholder {
  color: rgb(205, 205, 205);
}
.powrMark__text{
  display:none;
}
.closeButton{
    background-color: dodgerblue;
    text-align: center;
    border-radius: 5px;
    color: white;
    font-size: 2em;
    padding: 10px;
    border:0px;
}
label {
  margin-top:15px;
}

.custom_form {
  
  border:1px solid #333;
  width: 100%;
  padding: 12px 20px;
  margin-bottom: 8px;
  box-sizing: border-box;
}

.custom_form:focus {
  outline: none !important;
  border:1px solid #55B550;
  box-shadow: 0 0 4px #55B550;
}

.error {
  border:1px solid #800020;
  box-shadow: 0 0 4px #800020 ;
}


.hoverblue {
  color: #999;
  background-color: rgb(245, 245, 245);
  border-width: 0;
  font-weight: bold;
  font-size: 12px;    
  margin: 20px 1px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.hoverblue:hover{
  color: white;
  background-color: dodgerblue;
}

.negative-section{
  
  /*
    width:100%;
    margin-left: auto;
    margin-right: auto;
    margin-top: -100px;
    height:400px;    
    z-index:99;
  */    
}
.turngreen {
  transition: 0.3s;
  margin:10px;
}
.turngreen:hover {
   background-color:#55B550; 
   color:white; 
   border-radius: 5px;
   margin-bottom:10px;
}

@media only screen and (max-width: 600px) {  
  .negative-section{
      text-align:center;
  }
}

</style>
